// CharacterEquipmentScreen.jsx
import React from 'react';

const PUBLIC = process.env.PUBLIC_URL || '';

const equipmentData = [
  { id: 1, name: '은빛 투구',        desc: '추가 경험치 획득률 1%', icon: `${PUBLIC}/assets/helmet.png`, equipped: true  },
  { id: 2, name: '쇠 검',           desc: '추가 드랍 획득률 1%',      icon: `${PUBLIC}/assets/sword.png`,  equipped: true  },
  { id: 3, name: '은빛 신발',        desc: '추가 경험치 획득률 3%', icon: `${PUBLIC}/assets/boots.png`,   equipped: true  },
  { id: 4, name: '가죽 덧댄 하의', desc: '추가 경험치 획득률 5%', icon: `${PUBLIC}/assets/pants.png`,   equipped: false },
  { id: 5, name: '은빛 가죽 상의', desc: '추가 드랍 획득률 3%',      icon: `${PUBLIC}/assets/armor.png`,   equipped: false },
  { id: 6, name: '은빛 가죽 상의', desc: '추가 드랍 획득률 3%',      icon: `${PUBLIC}/assets/armor.png`,   equipped: false }
];

export default function CharacterEquipmentScreen({ onBack }) {
  const hideIfMissing = e => { e.target.style.display = 'none'; };
  const characterImg = `${PUBLIC}/assets/character.png`;

  return (
    <div className="container">
      {/* Header */}
      <header>
        <button className="back-button" onClick={onBack}>←</button>
        <div className="title">장비창</div>
        <button className="complete-button" onClick={onBack}>완료</button>
      </header>

      {/* Top Panel */}
      <div className="top-panel">
        <div className="slot helmet-slot">
          <span className="slot-label">Helmet</span>
          <div className="slot-icon">
            <img src={`${PUBLIC}/assets/helmet.png`} alt="Helmet" onError={hideIfMissing} />
          </div>
        </div>
        <div className="slot weapon-slot">
          <span className="slot-label">Weapon</span>
          <div className="slot-icon">
            <img src={`${PUBLIC}/assets/sword.png`} alt="Weapon" onError={hideIfMissing} />
          </div>
        </div>
        <div className="slot top-slot">
          <span className="slot-label">Top</span>
          <div className="slot-icon">
            <img src={`${PUBLIC}/assets/armor.png`} alt="Top" onError={hideIfMissing} />
          </div>
        </div>
        <div className="slot bottom-slot">
          <span className="slot-label">Bottom</span>
          <div className="slot-icon">
            <img src={`${PUBLIC}/assets/pants.png`} alt="Bottom" onError={hideIfMissing} />
          </div>
        </div>
        <div className="slot shoes-slot">
          <span className="slot-label">Shoes</span>
          <div className="slot-icon">
            <img src={`${PUBLIC}/assets/boots.png`} alt="Shoes" onError={hideIfMissing} />
          </div>
        </div>

        <img className="character-img" src={characterImg} alt="Character" onError={hideIfMissing} />

        <div className="stats">
          <div className="stat-item">Class: Warrior</div>
          <div className="stat-item">LV: 7</div>
          <div className="stat-item">EXP: 50</div>
        </div>
      </div>

      {/* Bottom Panel with Tabs */}
      <div className="bottom-panel">
        <div className="tabs">
          <button className="tab active">장비창</button>
          <button className="tab">캐시창</button>
        </div>
        <ul className="equipment-list">
          {equipmentData.map(item => (
            <li key={item.id} className="equipment-item">
              <div className="item-icon-container">
                <img className="item-icon" src={item.icon} alt={item.name} onError={hideIfMissing} />
              </div>
              <div className="info">
                <strong className="item-name">{item.name}</strong>
                <p className="item-desc">{item.desc}</p>
              </div>
              <div className="actions">
                <button className={`equip-button ${item.equipped ? 'equipped' : ''}`} disabled={item.equipped}>
                  {item.equipped ? '착용중' : '착용'}
                </button>
                {item.equipped && <button className="unequip-button">해제</button>}
              </div>
            </li>
          ))}
        </ul>
      </div>

      <style>{`
        .container {
          width:100vw; max-width:375px; height:100vh;
          background:#F6CD81; display:flex; flex-direction:column;
          overflow:hidden; font-family:sans-serif;
        }
        header {
          height:56px; display:flex; align-items:center;
          justify-content:space-between; padding:0 16px;
        }
        .back-button, .complete-button {
          background:none; border:none; font-size:16px;
          color:#333; cursor:pointer;
        }
        .title { font-size:18px; font-weight:bold; color:#333; }

        .top-panel {
          position:relative; height:300px;
          background:#F6CD81;
        }
        .slot {
          position:absolute; width:60px; height:60px;
          border:2px solid #333;
          display:flex; flex-direction:column; align-items:center;
        }
        .slot-label { font-size:12px; margin-top:2px; color:#333; }
        .slot-icon {
          flex:1; display:flex;
          align-items:center; justify-content:center;
        }
        .slot-icon img { width:36px; height:36px; }
        .helmet-slot { top:16px; left:16px; }
        .weapon-slot { top:96px; left:16px; }
        .top-slot    { top:16px; right:16px; }
        .bottom-slot { top:96px; right:16px; }
        .shoes-slot  { top:176px; right:16px; }
        .character-img {
          position:absolute; bottom:16px;
          left:50%; transform:translateX(-50%);
          width:120px;
        }
        .stats {
          position:absolute; top:80px;
          left:calc(50% + 70px);
          color:#333; font-size:14px;
          line-height:1.6;
        }
        .stat-item { margin-bottom:4px; }

        .bottom-panel {
          flex-grow:1; background:#fff;
          border-top-left-radius:16px;
          border-top-right-radius:16px;
          overflow-y:auto;
        }
        .tabs {
          display:flex; background:#fff;
          border-bottom:1px solid #eee;
        }
        .tab {
          flex:1; padding:12px 0;
          text-align:center; border:none;
          background:none; font-size:14px;
          color:#888; cursor:pointer;
          position:relative;
        }
        .tab.active {
          color:#333;
        }
        .tab.active::after {
          content:''; position:absolute;
          bottom:0; left:0; width:100%; height:2px;
          background:#333;
        }

        .equipment-list {
          list-style:none; margin:0;
          padding:0 16px 16px;
        }
        .equipment-item {
          display:flex; align-items:center;
          padding:8px 0; border-bottom:1px solid #eee;
        }
        .item-icon-container {
          width:56px; height:56px;
          border:2px solid #333;
          border-radius:8px;
          display:flex; align-items:center;
          justify-content:center;
          flex-shrink:0;
        }
        .item-icon { width:48px; height:48px; }
        .info { margin-left:12px; flex:1; }
        .item-name { font-size:14px; color:#333; }
        .item-desc { font-size:12px; color:#666; margin-top:4px; }
        .actions { display:flex; align-items:center; }
        .equip-button {
          padding:4px 8px; border:none; border-radius:4px;
          font-size:12px; color:#fff;
          background:#FFB84D; cursor:pointer;
        }
        .equip-button.equipped { background:#D18E00; }
        .equip-button:disabled { opacity:0.6; }
        .unequip-button {
          margin-left:8px; padding:4px 8px;
          border:none; border-radius:4px;
          font-size:12px; background:#e0e0e0;
          color:#333; cursor:pointer;
        }
      `}</style>
    </div>
  );
}
